import React, { ReactElement } from 'react';
import {
  Range,
  RANGE_VALUE_TYPE,
  STYLE_TYPE,
} from 'b2b-components/theme/components/Form/Range';
import { withField } from 'b2b-apps/shop/common/components/Form/withField';
import {
  EnhancedComponentType,
  WrappedComponentProps as Props,
  WrappedComponentType as ComponentType,
} from './';

const FormFieldRange: ComponentType = (props: Props): ReactElement => {
  const { innerComponentProps, field, form, ...otherProps } = props;

  return <Range {...innerComponentProps} {...field} {...otherProps} />;
};

const FormFieldRangeWithField: EnhancedComponentType = withField(FormFieldRange);

export {
  FormFieldRangeWithField as FormFieldRange,
  FormFieldRange as FormFieldRangeComponent,
  STYLE_TYPE as RANGE_STYLE_TYPE,
  RANGE_VALUE_TYPE,
};
